import React, { useState } from 'react';
import { Grid, Modal } from '@material-ui/core';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css/effect-coverflow';
import 'swiper/swiper-bundle.css';
import 'swiper/css/pagination';
import PlayCircleOutlineIcon from '@mui/icons-material/PlayCircleOutline';
import img1 from 'imagens/rosangela.png';
import img3 from 'imagens/tania.png';
import batepapo from 'imagens/batepapo.png';

import { EffectCoverflow, Pagination } from 'swiper/modules';
import { useDevice } from 'components/DeviceContext.js';

const VideosFia = () => {
    const [modalOpen, setModalOpen] = useState(false);
    const [currentVideoUrl, setCurrentVideoUrl] = useState('');
    const { isMobile, isDesktop, isLaptop } = useDevice();
    const [hoveredImageIndex, setHoveredImageIndex] = useState(null);

    const openModal = (videoUrl) => {
        setCurrentVideoUrl(videoUrl);
        setModalOpen(true);
    };

    const closeModal = () => {
        setCurrentVideoUrl('');
        setModalOpen(false);
    };

    const imagesWithVideos = [
        { imageUrl: img1, videoUrl: 'https://www.youtube.com/embed/fR8yPw1i_54?si=vKxlzbmytKDMBo5V', legenda: 'Campanha FIA | Entenda a importância para os Municípios' },
        { imageUrl: img3, videoUrl: 'https://www.youtube.com/embed/93_KnXTxO-k?si=u7Yxfm4LDOAGLaOa', legenda: 'FIA | Tânia Ziulkoski' },
        { imageUrl: batepapo, videoUrl: 'https://www.youtube.com/embed/cgdzPhBTlm8?si=7Xkjcc9JQ40CO2aX', legenda: '33 anos do Estatuto da Criança e do Adolescente (ECA)' },
        { imageUrl: batepapo, videoUrl: 'https://www.youtube.com/embed/PZutUWcrhfk?si=c6nhaldKjQy6qu1K', legenda: 'Bate-Papo com a CNM | FIA: Instrumento de Defesa dos Direitos da Criança e do Adolescente'  },
        { imageUrl: batepapo, videoUrl: 'https://www.youtube.com/embed/Q5DHwetZ3Bk?si=kppZPIo1ak2p7OFH', legenda: 'Bate-papo com a CNM | Fundo Municipal dos Direitos da Criança e do Adolescente (FIA)'  },
        { imageUrl: batepapo, videoUrl: 'https://www.youtube.com/embed/X9yHkrpYabg?si=xuUxnTMS-iUXTT-T', legenda: 'Bate-papo com a CNM | Fundo da Infância e Adolescência - Captação de Recursos'  },
    ];

    return (
        <>
            <Grid container align='center' style={{ backgroundColor: 'var(--azul-marinho)', padding: '5em 0', height: '80vh', textAlign: 'center' }}>
                <Grid item xs={12}>
                    <h1 style={{ color: 'var(--azul)', textAlign: 'center', fontWeight: '700', textTransform: 'uppercase', fontSize: '3em' }}>Vídeos</h1>
                </Grid>
                <Swiper
                    effect={'coverflow'}
                    grabCursor={true}
                    centeredSlides={false}
                    slidesPerView={isMobile ? 1 : 3}
                    spaceBetween={isMobile ? 10 : 30}
                    coverflowEffect={{
                        rotate: 50,
                        stretch: 0,
                        depth: 100,
                        modifier: 1,
                        slideShadows: true,
                    }}
                    pagination={{
                        clickable: true,
                    }}
                    modules={[EffectCoverflow, Pagination]}
                    className="mySwiper"
                >
                    {imagesWithVideos.map((item, index) => (
                        <SwiperSlide key={index} style={{ width: '100%', backgroundPosition: 'center', backgroundSize: 'cover' }}>
                            <Grid
                                onMouseEnter={() => setHoveredImageIndex(index)}
                                onMouseLeave={() => setHoveredImageIndex(null)}
                                style={{ position: 'relative', alignItems: 'center', justifyContent: 'center', display: 'flex' }}
                            >
                                <img style={{ height: isMobile ? '25vh' : isLaptop ? '30vh' : '35vh', width: isMobile ? '80%' : '100%' }}
                                    src={item.imageUrl}
                                    alt={`Image ${index}`}
                                    onClick={() => openModal(item.videoUrl)}
                                />
                                <PlayCircleOutlineIcon
                                    style={{
                                        position: 'absolute',
                                        top: '50%',
                                        left: '50%',
                                        transform: 'translate(-50%, -50%)',
                                        fontSize: '50px',
                                        color: hoveredImageIndex === index ? 'yellow' : 'white', // Change color on hover
                                        cursor: 'pointer'
                                    }}
                                    onClick={() => openModal(item.videoUrl)}
                                />
                                <h1 style={{ fontSize: isMobile ? '1em' : '1.2em', fontFamily: 'Roboto 600', position: 'absolute', bottom: '10px', left: isMobile ? '2.6em' : '34px', textAlign: 'left', color: 'white', zIndex: 1 }}>{item.legenda}</h1>
                            </Grid>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </Grid>
            <Modal open={modalOpen} onClose={closeModal}>
                <Grid style={{ position: 'absolute', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', backgroundColor: 'white', padding: '20px' }}>
                    <iframe style={{ width: isMobile ? '300px' : '600px', height: isDesktop ? '500px' : '300px' }} src={currentVideoUrl} title="YouTube video player" frameBorder="0" allowFullScreen></iframe>
                </Grid>
            </Modal>
        </>
    );
};

export default VideosFia;
